<template>
    <div class="d-flex box-cover display-box"
         :class="contentClass">
        <template v-if="cardContent">
            <div class="card w-100 h-100 p-1">
                <slot></slot>
            </div>
        </template>
        <template v-else>
            <slot></slot>
        </template>
    </div>
</template>

<script>
import {isNeedCleanApp} from "@/utils/mobileUtil";

export default {
    name: "AppContent",
    props: {
        flexColumn: {
            type: Boolean,
            default: false
        },
        cardContent: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        isCleanMode() {
            return isNeedCleanApp(window.location.pathname);
        },
        contentClass() {
            let tempList = [];
            tempList.push(this.flexColumn ? 'flex-column' : 'flex-row');
            if (!this.isCleanMode) {
                tempList.push('app-content shrink');
            }
            return tempList.join(" ");
        },
    },
}
</script>

<style scoped>
.box-cover {
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    position: absolute;
    /* 固定视口面板：横向溢出直接裁剪，禁止把横向滚动冒泡到 .router-view-body。
       仅裁剪 X 轴时，Y 轴按规范降级为 auto，纵向内容仍可正常滚动。
       表格 / 筛选条各自的 overflow-auto 负责内部横向滚动。 */
    overflow-x: hidden;
    min-width: 0;
    min-height: 0;
}

/* 让 flex 子项（卡片）能收缩到面板宽度，而不是被内容撑宽 */
.box-cover > .card {
    min-width: 0;
    min-height: 0;
}

.shrink {
    padding-top: 62px;
}
</style>
